<!-- Breadcrumb Container -->
<div class="container p-0">
    <div class="row" style="align-items: baseline">
       <div class="col-xl-11">
          <nav
                class="breadcrumb"
                aria-label="breadcrumb"
                *ngIf="modelBreadCrumb != null"
            >
             <ol class="breadcrumb">
                <li [class]="'breadcrumb-item '" *ngFor="let breadcrumbItem of modelBreadCrumb.last; index as i">
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && !breadcrumbItem.seccion"  [routerLink]="[breadcrumbItem.url]" > {{breadcrumbItem.nombre}}</a>
                   <a class="textoBrdCrumb"  *ngIf="breadcrumbItem.dataConsult"  (click)="back()" > {{breadcrumbItem.nombre}}</a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 1"  (click)="regresar()" >{{breadcrumbItem.nombre}} </a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 2"  (click)="usersConsult()" >{{breadcrumbItem.nombre}} </a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 3"  (click)="backEntidad()" >{{breadcrumbItem.nombre}} </a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 4"  (click)="backCapa()" >{{breadcrumbItem.nombre}} </a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 5"  (click)="cancelEditCapa()" >{{breadcrumbItem.nombre}} </a>
                   <a class="textoBrdCrumb"  *ngIf="!breadcrumbItem.dataConsult && breadcrumbItem.seccion == 6"  (click)="backVersionarCapa()" >{{breadcrumbItem.nombre}} </a>
                   <!-- "['/app/home']",  "['/app/administration']", Inicio,  Administración  -->
                </li>
                <li [class]="'breadcrumb-item active'" aria-current="page">
                      <span class="breadcrumb-text item-link">{{modelBreadCrumb.current}}</span>
                </li>
             </ol>
          </nav>
       </div>
       <div class="col-xl-1 mt-2" style="text-align: right">
          <span class="col-md-2 etiquetaRol">
             {{ this.userData.rol.nombre }}
          </span>
       </div>
    </div>
 </div>
